import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import CommonSelect from "../../../core/common/commonSelect";
import { showBasicAlert } from "../../../core/common/useAlert";
import api from "../../../services/api";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../../../core/common/loader";

const EditEmployee = (props: any) => {
  let { data = { key: "" }, onClose } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [roleInput, setRoleInput] = useState("");

  const user = useSelector((state: any) => state.user.user);
  const [selectedDepartmentKey, setSelectedDepartmentKey] = useState<string | number>("");
  const [allDesignations, setAllDesignations] = useState<any[]>([]);

  // Head replacement modal state
  const [showHeadReplacementModal, setShowHeadReplacementModal] = useState(false);
  const [subordinatesList, setSubordinatesList] = useState<any[]>([]);
  const [selectedNewHeadId, setSelectedNewHeadId] = useState<number | null>(null);
  const [pendingSubmitData, setPendingSubmitData] = useState<any>(null);

  const today = dayjs();
  const normalizeDate = (dateStr: any) => {
    if (!dateStr) return "";

    // Handle different date formats
    if (dateStr.includes("T")) {
      // ISO format like "1995-06-02T18:30:00.000Z"
      return dayjs(dateStr).format("DD-MM-YYYY");
    } else if (dateStr.includes("-")) {
      // Already in DD-MM-YYYY or similar format
      const parts = dateStr.split("-");
      if (parts.length === 3) {
        // Ensure DD-MM-YYYY format
        const day = parts[0].padStart(2, "0");
        const month = parts[1].padStart(2, "0");
        const year = parts[2];
        return `${day}-${month}-${year}`;
      }
    }
    return dateStr;
  };

  // Fix the initial data setup
  var joiningDate = data?.JoiningDate;
  var dob = data?.DOB;
  var dol = data?.dol;

  // If JoiningDate is in "28-03-2025" format, parse it correctly
  if (joiningDate && joiningDate.includes("-") && !joiningDate.includes("T")) {
    const [day, month, year] = joiningDate.split("-");
    joiningDate = `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
  } else {
    joiningDate = normalizeDate(joiningDate);
  }

  dob = normalizeDate(dob);
  dol = normalizeDate(dol);
  var initialAddEmployyeFormData = {
    id: data?.key || "",
    signature: data?.signature || "",
    salutation: data?.Salutation || "",
    firstName: data?.Fname || "",
    lastName: data?.Lname || "",
    gender: data?.Gender || "",
    countryCode: data?.Phone_code || "",
    phoneNumber: data?.Phone_Number || "",
    official_countryCode: data?.Official_Phone_code || "",
    official_phoneNumber: data?.Official_Phone_Number || "",
    reportingOfficer: data?.ReportingOfficerId || 0,
    designationKey: data?.DesignationId || "",
    designation: data?.Designation || "",
    email: data?.Email,
    DOB: dob,
    JoiningDate: joiningDate,
    dol: dol,
    profileUrl: data?.Image || "",
    status: data?.Status == "Active" ? 1 : data?.Status == "Suspended" ? 3 : 0,
    essl_id: data?.essl_id == null ? "" : data?.essl_id,
    responsibilities: data?.Responsibilities || [], // Initialize as array of role values
    userType: data?.role_char || "",
    departmentAccess: data?.departmentAccess,
    is_work_from: data?.is_work_from !== undefined ? data?.is_work_from : null,
    is_biometric_enable:
      data?.is_biometric_enable !== undefined
        ? data?.is_biometric_enable
        : null,
  };

  const [imagePreview, setImagePreview] = useState<any | null>(null);
  const [formDataAddEmployee, setformDataAddEmployee] = useState(
    initialAddEmployyeFormData
  );
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (data?.DepartmentId) {
      setSelectedDepartmentKey(data.DepartmentId);
    }
    setformDataAddEmployee(initialAddEmployyeFormData);
  }, [data]);
  useEffect(() => {
    if (data?.getDesignation) {
      setAllDesignations(data.getDesignation);
    }
  }, [data]);

  const handleFileChange = async (e: any) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile || !selectedFile.type.startsWith("image/")) {
      showBasicAlert("Please select a valid image file.");
      return;
    }

    // Set uploading state to show loader
    setIsUploadingImage(true);

    try {
      const result = await uploadFileToCloudinary(selectedFile);
      if (result?.secure_url) {
        setIsImageLoading(true);

        setImagePreview({
          preview: result.secure_url,
          data: result.secure_url,
        });
        setformDataAddEmployee((prev: any) => ({
          ...prev,
          profileUrl: result.secure_url,
        }));
      }
    } catch (error) {
      console.error("Upload error:", error);
      showBasicAlert("Failed to upload image. Please try again.");
    } finally {
      // Always reset uploading state
      setIsUploadingImage(false);
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const handleImageError = () => {
    setIsImageLoading(false);
    showBasicAlert("Failed to load image. Please try again.");
  };

  useEffect(() => {
    setformDataAddEmployee(initialAddEmployyeFormData);
    if (data?.Image) {
      setIsImageLoading(true);
    }
  }, [data]);

  const uploadFileToCloudinary = async (file: File) => {
    const UPLOAD_PRESET: any = process.env.REACT_APP_UPLOAD_PRESET;
    const CLOUDINARY_URL = `${process.env.REACT_APP_API_CLOUDNIRY_URL}/${process.env.REACT_APP_CLOUD_NAME}/upload`;
    const FOLDER_PATH = "cms/profile_pic/" + user?.userDetails.id;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);
    formData.append("folder", FOLDER_PATH);

    try {
      const response = await axios.post(CLOUDINARY_URL, formData);
      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      showBasicAlert("Failed to upload file. Please try again.");
      return null;
    }
  };

  const handleCountryCodeChange = (e: any) => {
    const country_code = e.target.value;
    setformDataAddEmployee((prevData) => ({
      ...prevData,
      countryCode: country_code,
    }));
  };

  const getFilteredDesignations = () => {
    if (!selectedDepartmentKey || !allDesignations.length) {
      return (allDesignations || []).map((designation: any) => ({
        value: designation.key,
        label: designation.Designation,
      }));
    }
    return allDesignations
      .filter((designation: any) => designation.Department_id == selectedDepartmentKey)
      .map((designation: any) => ({
        value: designation.key,
        label: designation.Designation,
      }));
  };

  const filteredDesignationChoose = getFilteredDesignations();

  const reportingOfficerChoose = (data?.getReportingOfficer ?? []).map(
    (officer: any) => ({
      value: officer.key,
      label: `${officer.name} - ${officer.Designation} - ${officer.Department}`,
    })
  );

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setformDataAddEmployee((prev) => ({ ...prev, [name]: value }));
  };

  const handleRoleInputChange = (e: any) => {
    setRoleInput(e.target.value);
  };

  const handleresponsibilitiesubmit = (e: any) => {
    e.preventDefault();
    if (roleInput.trim() === "") {
      showBasicAlert("Please enter a role.");
      return;
    }
    setformDataAddEmployee((prev: any) => ({
      ...prev,
      responsibilities: [...prev.responsibilities, roleInput.trim()],
    }));
    setRoleInput(""); // Clear input after adding
  };

  const handleRoleRemove = (roleToRemove: string) => {
    setformDataAddEmployee((prev: any) => ({
      ...prev,
      responsibilities: prev.responsibilities.filter(
        (role: string) => role !== roleToRemove
      ),
    }));
  };

  const handleSubmit = async (e?: any, overrideNewHeadId?: number | null) => {
    try {
      if (formDataAddEmployee.status == 3 && !formDataAddEmployee.dol) {
        showBasicAlert("Please select Date of Leaving for suspended employees");
        return;
      }
      setIsLoading(true);
      const submitData: any = { ...formDataAddEmployee };
      submitData.signature = data?.signature;
      if (overrideNewHeadId) {
        submitData.newHeadId = overrideNewHeadId;
      }
      const response = await api.post(
        "userService/updateEmployee",
        submitData
      );
      const result = response.data?.message[0];

      // Check if backend says this user is a head and needs replacement
      if (result?.isHead && !result?.status) {
        setIsLoading(false);
        setSubordinatesList(result.subordinates || []);
        setPendingSubmitData(submitData);
        setShowHeadReplacementModal(true);
        return;
      }

      showBasicAlert(result.msg);
      setIsLoading(false);
      if (result.status) {
        onClose();
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleHeadReplacementSubmit = async () => {
    if (!selectedNewHeadId) {
      showBasicAlert("Please select a new head for the department");
      return;
    }
    setShowHeadReplacementModal(false);
    await handleSubmit(undefined, selectedNewHeadId);
    setSelectedNewHeadId(null);
    setSubordinatesList([]);
    setPendingSubmitData(null);
  };

  const handleHeadReplacementCancel = () => {
    setShowHeadReplacementModal(false);
    setSelectedNewHeadId(null);
    setSubordinatesList([]);
    setPendingSubmitData(null);
  };

  const salutation = [
    { value: "Mr.", label: "Mr" },
    { value: "Mrs.", label: "Mrs" },
    { value: "Ms.", label: "Ms" },
    { value: "Dr.", label: "Dr" },
  ];

  const gender = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "O", label: "Other" },
  ];

  // Original status from data (before any edits)
  const originalStatus = data?.Status;

  const status = [
    { value: 1, label: "Active", disabled: originalStatus === "Suspended" },
    { value: 0, label: "Inactive", disabled: originalStatus === "Suspended" },
    { value: 3, label: "Suspended" },
  ];

  const workFromOptions = [
    { value: 0, label: "Work from Home" },
    { value: 1, label: "Work from Office" },
  ];

  const biometricOptions = [
    { value: 0, label: "Disabled" },
    { value: 1, label: "Enabled" },
  ];

  const handleDolChange = (date: any) => {
    if (date) {
      const formattedDate = date.format("DD-MM-YYYY");
      setformDataAddEmployee((prev: any) => ({
        ...prev,
        dol: formattedDate,
      }));
    } else {
      setformDataAddEmployee((prev: any) => ({
        ...prev,
        dol: "",
      }));
    }
  };

  const handleJoiningDateChange = (date: any) => {
    if (date) {
      const formattedDate = date.format("DD-MM-YYYY");
      setformDataAddEmployee((prev: any) => ({
        ...prev,
        JoiningDate: formattedDate,
      }));
    }
  };

  const handleDOBChange = (date: any) => {
    if (date) {
      const formattedDate = date.format("DD-MM-YYYY");
      setformDataAddEmployee((prev: any) => ({
        ...prev,
        DOB: formattedDate,
      }));
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("edit_employee");
    return modalElement ? modalElement : document.body;
  };

  const emojiFromUPlus = (val?: string) => {
    if (!val) return "";
    // pick all U+XXXXXX tokens, fallback to split by non-hex
    const tokens =
      val.match(/U\+[0-9A-F]{4,6}/gi)?.map((t) => t.slice(2)) ||
      val
        .replace(/U\+/gi, "")
        .split(/[^0-9A-F]+/i)
        .filter(Boolean);

    return String.fromCodePoint(...tokens.map((h) => parseInt(h, 16)));
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="modal fade" id="edit_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Edit Employee</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleresponsibilitiesubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames position-relative">
                            {isImageLoading && (
                              <div className="position-absolute top-50 start-50 translate-middle">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading image...
                                  </span>
                                </div>
                              </div>
                            )}
                            <img
                              src={
                                imagePreview?.preview ||
                                data?.Image ||
                                "assets/img/users/user.png"
                              }
                              alt="Profile preview"
                              className="rounded-circle"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                opacity: isImageLoading ? 0.5 : 1,
                              }}
                              onLoad={handleImageLoad}
                              onError={handleImageError}
                            />
                          </div>
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 mb
                              </p>
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div
                                className={`drag-upload-btn btn btn-sm btn-primary me-2 ${isUploadingImage ? "uploading" : ""
                                  }`}
                              >
                                {isUploadingImage ? (
                                  <>
                                    <div
                                      className="spinner-border spinner-border-sm text-white me-1"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                    Uploading...
                                  </>
                                ) : (
                                  "Upload"
                                )}
                                <input
                                  ref={fileInputRef}
                                  name="file"
                                  type="file"
                                  accept="image/*"
                                  className="form-control image-sign"
                                  onChange={handleFileChange}
                                  disabled={isUploadingImage || isImageLoading}
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor:
                                      isUploadingImage || isImageLoading
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                />
                              </div>
                              {(imagePreview || data?.Image) &&
                                !isUploadingImage &&
                                !isImageLoading && (
                                  <Link
                                    to="#"
                                    className="btn btn-light btn-sm"
                                    onClick={() => {
                                      setImagePreview({
                                        preview: "",
                                        data: "",
                                      });
                                      // Reset the file input when canceling
                                      if (fileInputRef.current) {
                                        fileInputRef.current.value = "";
                                      }
                                    }}
                                  >
                                    Cancel
                                  </Link>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Salutation <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="salutation"
                            value={formDataAddEmployee.salutation}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {salutation.map((data: any) => (
                              <option key={data?.value} value={data?.value}>
                                {data?.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={formDataAddEmployee.firstName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Last Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={formDataAddEmployee.lastName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">Essl Id</label>
                          <input
                            type="text"
                            className="form-control"
                            name="essl_id"
                            value={formDataAddEmployee.essl_id}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Gender <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="gender"
                            value={formDataAddEmployee.gender}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {gender.map((data: any) => (
                              <option key={data?.value} value={data?.value}>
                                {data?.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-5">
                        <div className="mb-3">
                          <label className="form-label">
                            D.O.B ({formDataAddEmployee.DOB})
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              value={dayjs(
                                formDataAddEmployee.DOB,
                                "DD-MM-YYYY"
                              )}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              onChange={handleDOBChange}
                              maxDate={today}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="mb-3">
                          <label className="form-label">
                            Joining Date ({formDataAddEmployee.JoiningDate})
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              value={dayjs(
                                formDataAddEmployee.JoiningDate,
                                "DD-MM-YYYY"
                              )}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              onChange={handleJoiningDateChange}
                              maxDate={today}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formDataAddEmployee.email}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Country Code <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="countryCode"
                            value={formDataAddEmployee.countryCode}
                            onChange={handleCountryCodeChange}
                          >
                            <option value="">Select</option>
                            {(data?.CountryCode ?? []).map(
                              (country: any, index: number) => (
                                <option key={index} value={country.phonecode}>
                                  {country.ios2}{" "}
                                  {emojiFromUPlus(country.emojiU)}
                                  {" +"}
                                  {country.phonecode}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="tel"
                            className="form-control no-spinners"
                            name="phoneNumber"
                            value={formDataAddEmployee.phoneNumber}
                            onChange={handleInputChange}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.value = target.value
                                .replace(/\D/g, "")
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Country Code <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="official_countryCode"
                            value={formDataAddEmployee.official_countryCode}
                            onChange={handleCountryCodeChange}
                          >
                            <option value="">Select</option>
                            {(data?.CountryCode ?? []).map(
                              (country: any, index: number) => (
                                <option key={index} value={country.phonecode}>
                                  {country.ios2}{" "}
                                  {emojiFromUPlus(country.emojiU)}
                                  {" +"}
                                  {country.phonecode}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Official Phone Number{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            name="official_phoneNumber"
                            value={formDataAddEmployee.official_phoneNumber}
                            onChange={handleInputChange}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.value = target.value
                                .replace(/\D/g, "")
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Designation
                            <span className="text-danger"> *</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={filteredDesignationChoose}
                            defaultValue={{
                              value: formDataAddEmployee.designationKey,
                              label: formDataAddEmployee.designation,
                            }}
                            // isDisabled={!selectedDepartmentKey}
                            onChange={(selectedOption: any) =>
                              setformDataAddEmployee((prev: any) => ({
                                ...prev,
                                designation: selectedOption.label,
                                designationKey: selectedOption.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Reporting Officer{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="reportingOfficer"
                            value={formDataAddEmployee.reportingOfficer}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {reportingOfficerChoose.map((data: any) => (
                              <option key={data?.value} value={data?.value}>
                                {data?.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Status <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            value={formDataAddEmployee.status}
                            onChange={handleInputChange}
                            disabled={originalStatus === "Suspended"} 
                          >
                            <option value="">Select</option>
                            {status.map((data: any) => (
                              <option key={data?.value} value={data?.value} disabled={data?.disabled}>
                                {data?.label}{data?.disabled ? " (Blocked)" : ""}
                              </option>
                            ))}
                          </select>
                          {formDataAddEmployee.status == 3 && (
                            <small className="text-warning">
                              <i className="ti ti-info-circle me-1" />
                              Date of Leaving is required for suspended employees
                            </small>
                          )}
                          {formDataAddEmployee.status == 3 && (
                            <small className="text-danger d-block mt-1">
                              <i className="ti ti-alert-triangle me-1" />
                              Warning: Suspended accounts cannot be reactivated.
                            </small>
                          )}
                          {formDataAddEmployee.status == 1 && formDataAddEmployee.dol && (
                            <small className="text-info">
                              <i className="ti ti-info-circle me-1" />
                              This account was previously inactive with DOL ({formDataAddEmployee.dol}) and has been reactivated. DOL is preserved in the system.
                            </small>
                          )}
                        </div>
                      </div>
                      {formDataAddEmployee.status == 3 && (
                        <div className="col-md-5">
                          <div className="mb-3">
                            <label className="form-label">
                              Date of Leaving {formDataAddEmployee.dol && `(${formDataAddEmployee.dol})`}
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="input-icon-end position-relative">
                              <DatePicker
                                className="form-control datetimepicker"
                                format={{
                                  format: "DD-MM-YYYY",
                                  type: "mask",
                                }}
                                value={formDataAddEmployee.dol ? dayjs(formDataAddEmployee.dol, "DD-MM-YYYY") : null}
                                getPopupContainer={getModalContainer}
                                placeholder="DD-MM-YYYY"
                                onChange={handleDolChange}
                                maxDate={today}
                                disabled={data?.dol ? true : false}
                              />
                              <span className="input-icon-addon">
                                <i className="ti ti-calendar text-gray-7" />
                              </span>
                            </div>
                            <small className="text-muted">
                              Select the date when employee left the company
                            </small>
                          </div>
                        </div>
                      )}

                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            User Type <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="userType"
                            value={formDataAddEmployee.userType}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="Employee">Employee</option>
                            <option value="EmployeeAdmin">Admin</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Department Access{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="departmentAccess"
                            value={formDataAddEmployee.departmentAccess}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Roles and Responsibilities{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="d-flex align-items-center mb-2">
                            <input
                              type="text"
                              className="form-control me-2"
                              name="role"
                              value={roleInput}
                              onChange={handleRoleInputChange}
                              placeholder="Enter a role"
                            />
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary"
                            >
                              Add
                            </button>
                          </div>
                          {formDataAddEmployee.responsibilities.length > 0 && (
                            <div className="mt-2">
                              <strong>Current responsibilities:</strong>
                              <ul className="list-unstyled mb-0">
                                {formDataAddEmployee.responsibilities.map(
                                  (role: string, index: number) => (
                                    <li
                                      key={index}
                                      className="d-flex align-items-center mb-1"
                                    >
                                      <span className="badge bg-light text-dark me-2">
                                        {role}
                                        <button
                                          type="button"
                                          className="btn btn-link text-danger p-0 ms-2"
                                          onClick={() => handleRoleRemove(role)}
                                        >
                                          <i className="ti ti-x" />
                                        </button>
                                      </span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Work From</label>
                          <select
                            className="form-control"
                            name="is_work_from"
                            value={
                              formDataAddEmployee.is_work_from !== null
                                ? formDataAddEmployee.is_work_from
                                : ""
                            }
                            onChange={handleInputChange}
                          >
                            <option value="">Select Option</option>
                            {workFromOptions.map((option: any) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Biometric Access{" "}
                          </label>
                          <select
                            className="form-control"
                            name="is_biometric_enable"
                            value={
                              formDataAddEmployee.is_biometric_enable !== null
                                ? formDataAddEmployee.is_biometric_enable
                                : ""
                            }
                            onChange={handleInputChange}
                          >
                            <option value="">Select Option</option>
                            {biometricOptions.map((option: any) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Head Replacement Modal */}
      {showHeadReplacementModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }} tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Replace Department Head</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleHeadReplacementCancel}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning">
                  <i className="ti ti-alert-triangle me-2" />
                  This user is currently a department head. You must select a replacement for their {subordinatesList.length} subordinates before deactivating/suspending.
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Select Replacement Head</label>
                  <select
                    className="form-control"
                    value={selectedNewHeadId || ""}
                    onChange={(e) => setSelectedNewHeadId(parseInt(e.target.value))}
                  >
                    <option value="">-- Select New Head --</option>
                    {/* Filter out the user themselves but show all other valid heads/reporting officers to prevent empty lists */}
                    {data?.getReportingOfficer
                      ?.filter((ro: any) => String(ro.key) !== String(data?.id))
                      ?.map((ro: any) => (
                        <option key={ro.key} value={ro.key}>
                          {ro.name} ({ro.Designation} - {ro.Department})
                        </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2 fw-bold text-muted" style={{ fontSize: '13px' }}>
                    The following employees will be reassigned:
                  </label>
                  <div style={{ maxHeight: "150px", overflowY: "auto", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "5px" }}>
                    <ul className="mb-0 ps-3">
                      {subordinatesList.map((sub: any) => (
                        <li key={sub.id} style={{ fontSize: "13px" }}>{sub.name}</li>
                      ))}
                    </ul>
                  </div>
                </div>

              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  onClick={handleHeadReplacementCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleHeadReplacementSubmit}
                  disabled={!selectedNewHeadId}
                >
                  Save & Reassign
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditEmployee;
